import {Injectable} from '@angular/core';
import {RequesterService} from '../../../services/requester.service';
import {DelegateSimpleModel, DelegateSummaryModel, TeamDetailsModel} from '../models/delegate.model';
import {NavController} from '@ionic/angular';
import {UserJourneyModel, UserJourneysModel} from '../../journey/models/journey-page.model';
import {Subscription} from 'rxjs';
import {EventsService} from '../../../services/events.service';

@Injectable({
  providedIn: 'root'
})
export class TeamService {

  teamManagerId = 0;
  teamList: DelegateSummaryModel[] = null;

  constructor(
    private event: EventsService,
    private navCtrl: NavController,
    private requesterService: RequesterService
  ) {
    this.event.subscribe('login', () => {
      this.teamManagerId = 0;
      this.teamList = null;
    });
  }

  getUserJourney(delegateId: number): Promise<UserJourneyModel> {
    return this.requesterService.get('getUserJourney', {del_id: delegateId})
      .then(data => {
        return data.result;
      })
      .catch(e => {
        console.log('Error getUserJourney >> ', e);
      });
  }

  getUserJourneys(delegateId: number): Promise<UserJourneysModel> {
    return this.requesterService.get('getUserJourneys', {del_id: delegateId})
      .then(data => {
        return data.result;
      })
      .catch(e => {
        console.log('Error getUserJourneys >> ', e);
      });
  }

  getTeamDetails(delegateId: number): Promise<TeamDetailsModel> {
    return this.requesterService.get('getUserJourneySummary', {del_id: delegateId})
      .then(data => {
        return data.result;
      })
      .catch(e => {
        console.log('Error getMyJourneyInfo >> ', e);
      });
  }

  getMyTeamList(managerId: number = 0): Promise<DelegateSummaryModel[]> {
    return this.requesterService.get('getMyTeamList', {manager_id: managerId})
      .then(data => {
        this.teamManagerId = managerId;
        this.teamList = data.result.map(item => {
          return {...item, hb_calls: { average: Math.floor((0.25 + Math.random() / 2)  * 100)}};
        });
        return this.teamList;
      })
      .catch(e => {
        console.log('Error getMyJourneyStage >> ', e);
        return null;
      });
  }

  getMyTeamListModel() {
    if (this.teamList === null) {
      return this.getMyTeamList();
    }
    return Promise.resolve(this.teamList);
  }

  getMyManagersList(managerId: number=0): Promise<DelegateSimpleModel[]> {
    let endpoint = 'getMyManagersList';
    if (managerId) {
      endpoint += '?manager_id=' + managerId;
    }

    return this.requesterService.get(endpoint)
      .then(data => {
        if (!!data.result) {
          return data.result;
        }
        return [];
      })
      .catch(e => {
        return [];
        console.log('Error getMyJourneyStage >> ', e);
      });
  }

  getUserHBMagicLink(del_id, url): Promise<any> {
    return this.requesterService.get('getUserHBMagicLink', {del_id, url})
      .then(data => {
        if (!!data.result) {
          return data.result;
        }
        return null;
      })
      .catch(e => {
        return null;
        console.log('Error getUserHBMagicLink >> ', e);
      });
  }
}
